export default __webpack_public_path__ + "static/media/Suyane_Mike_HickDuarte_32913.d6237414.jpg";